var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBlueShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 22.9167C43.75 34.4792 35.75 45.2917 25 47.9167C14.25 45.2917 6.25 34.4792 6.25 22.9167V10.4167L25 2.08337L43.75 10.4167V22.9167ZM25 43.75C32.8125 41.6667 39.5833 32.375 39.5833 23.375V13.125L25 6.62504L10.4167 13.125V23.375C10.4167 32.375 17.1875 41.6667 25 43.75ZM20.8333 35.4167L12.5 27.0834L15.4375 24.1459L20.8333 29.5209L34.5625 15.7917L37.5 18.75",
    fill: "#0067EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlueShield);
export default __webpack_public_path__ + "static/media/icoBlueShield.c7518ee1a037033cdf27c9445ad6a031.svg";
export { ForwardRef as ReactComponent };